import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaUserEdit, FaTrophy, FaMoneyCheckAlt, FaEye, FaShieldAlt } from 'react-icons/fa';
import "./styles/Rules.css";

const Rules = () => {
  return (
    <main className="rules">
      <Helmet>
        <title>Règles du jeu - WinlyDeal</title>
        
        <meta 
          name="description" 
          content="Découvrez les règles de participation sur WinlyDeal : conditions d'accès, détermination du gagnant, paiements sécurisés, transparence des contributions et responsabilités des utilisateurs." 
        />
        <meta 
          name="keywords" 
          content="règles, conditions de participation, gagner produit, WinlyDeal, paiement sécurisé, transparence, responsabilité utilisateur"
        />
        <link rel="canonical" href="https://winlydeal.com/rules" />
        
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Conditions de participation - WinlyDeal" />
        <meta 
          property="og:description" 
          content="Consultez toutes les règles et conditions pour participer aux offres et remporter des produits exceptionnels sur WinlyDeal." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://winlydeal.com/rules" />
        <meta property="og:image" content="https://winlydeal.com/images/og-image.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Conditions de participation - WinlyDeal" />
        <meta 
          name="twitter:description" 
          content="Découvrez les règles essentielles pour contribuer et tenter de remporter des produits sur WinlyDeal." 
        />
        <meta name="twitter:image" content="https://winlydeal.com/images/og-image.jpg" />
      </Helmet>

      <section className="rules-header">
        <h1 className="rules-title">Règles et Conditions de Participation</h1>
        <p className="rules-intro">
          Bienvenue sur WinlyDeal ! Avant de contribuer à nos offres exclusives, merci de prendre connaissance des règles suivantes pour garantir une expérience juste et transparente pour tous.
        </p>
      </section>

      <section className="rules-section">
        <div className="rules-icon"><FaUserEdit /></div>
        <h2 className="rules-subtitle"><span className="rules-badge">1</span> Participation</h2>
        <p className="rules-text">
          - Chaque participant peut contribuer à l'achat d'un produit dans la limite fixée pour chaque offre.
        </p>
        <p className="rules-text">
          - Une seule contribution est autorisée toutes les 24 heures par utilisateur pour éviter les abus.
        </p>
      </section>

      <section className="rules-section">
        <div className="rules-icon"><FaTrophy /></div>
        <h2 className="rules-subtitle"><span className="rules-badge">2</span> Détermination du gagnant</h2>
        <p className="rules-text">
          - Le gagnant est le participant ayant contribué le montant le plus élevé au moment de la clôture.
        </p>
        <p className="rules-text">
          - En cas d'égalité parfaite, la contribution la plus ancienne parmi les montants les plus élevés sera prioritaire.
        </p>
      </section>

      <section className="rules-section">
        <div className="rules-icon"><FaMoneyCheckAlt /></div>
        <h2 className="rules-subtitle"><span className="rules-badge">3</span> Paiement et remboursement</h2>
        <p className="rules-text">
          - Les paiements sont traités via nos partenaires sécurisés Stripe et PayPal.
        </p>
        <p className="rules-text">
          - Si l'objectif de collecte n'est pas atteint, l'intégralité des contributions est remboursée.
        </p>
      </section>

      <section className="rules-section">
        <div className="rules-icon"><FaEye /></div>
        <h2 className="rules-subtitle"><span className="rules-badge">4</span> Transparence</h2>
        <p className="rules-text">
          - Le montant collecté et le nombre de participants sont affichés en temps réel sur chaque fiche produit.
        </p>
        <p className="rules-text">
          - Les règles sont accessibles depuis chaque page de produit afin de garantir une totale transparence.
        </p>
      </section>

      <section className="rules-section">
        <div className="rules-icon"><FaShieldAlt /></div>
        <h2 className="rules-subtitle"><span className="rules-badge">5</span> Responsabilité</h2>
        <p className="rules-text">
          - WinlyDeal se réserve le droit de suspendre ou d'annuler une participation en cas de comportement frauduleux ou de non-respect des conditions d'utilisation.
        </p>
        <p className="rules-text">
          - Les utilisateurs doivent fournir des informations exactes lors de leur inscription pour garantir l'équité des résultats.
        </p>
      </section>

      <section className="rules-footer">
        <p className="rules-note">
          Pour toute question, merci de consulter notre FAQ ou de contacter notre service support à l'adresse <a href="mailto:support@winlydeal.com" className="rules-link">support@winlydeal.com</a>.
        </p>
        <button
          className="rules-button"
          onClick={() => window.location.href = "/"}
        >
          Retour à l'accueil
        </button>
      </section>
    </main>
  );
};

export default Rules;
